let swiperTestimonial = null;

function initTestimonialSwiper() {
  const swiperContainer = document.querySelector(".swiper-testimonial");
  if (!swiperContainer) return;

  const itemCount = parseInt(swiperContainer.dataset.itemCount) || 0;
  const isTabletOrDesktop = window.innerWidth >= 768;

  // Destroy existing swiper if it exists
  if (swiperTestimonial && swiperTestimonial.destroy) {
    swiperTestimonial.destroy(true, true);
    swiperTestimonial = null;
  }

  // On mobile: always enable swiper
  // On tablet/desktop: only enable if more than 3 items
  const shouldEnableSwiper = !isTabletOrDesktop || itemCount > 3;

  if (shouldEnableSwiper) {
    swiperTestimonial = new Swiper(".swiper-testimonial", {
      loop: itemCount > 1,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 24,
      pagination: {
        el: ".testimonial-pagination",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 0,
        },
      },
    });
  } else {
    // Remove swiper classes when disabled on tablet/desktop
    swiperContainer.classList.remove("swiper-initialized", "swiper-horizontal");
    const wrapper = swiperContainer.querySelector(".swiper-wrapper");
    if (wrapper) {
      wrapper.style.transform = "";
      wrapper.style.transitionDuration = "";
    }
  }
}

// Initialize on load
initTestimonialSwiper();

// Re-initialize on resize
let resizeTimeout;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initTestimonialSwiper, 250);
});
